import type { FunctionComponent } from "react";

import { HeaderBottom } from "~/components/header/header-bottom";

import { ContentContainer, StyledMorningStudioLogo, SubheaderContainer } from "./styles";

type Props = {
  className?: string;
};

export const MorningStudioMobileSubheader: FunctionComponent<Props> = ({ className }) => (
  <HeaderBottom>
    <SubheaderContainer className={className}>
      <ContentContainer>
        <StyledMorningStudioLogo />
      </ContentContainer>
    </SubheaderContainer>
  </HeaderBottom>
);
MorningStudioMobileSubheader.displayName = "MorningStudioMobileSubheader";
